import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-more-menu-popover',
  templateUrl: './more-menu-popover.component.html',
  styleUrls: ['./more-menu-popover.component.scss'],
})
export class MoreMenuPopoverComponent implements OnInit {

  @Input() moreMenuItemLists:any;
  @Input() alignment: string = 'center';
  constructor(private popoverCtl:PopoverController) { }

  ngOnInit() {}

  close() {
    this.popoverCtl.dismiss();
  }

  selectItemMenu(value:string){
    this.popoverCtl.dismiss(value)
  }

  getAlignmentText() {
    return this.alignment;
  }
}
